import { matcherToArray } from './matcherToArray';
/** Create CustomModifiers from dayModifiers */
export function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function (_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}
//# sourceMappingURL=getCustomModifiers.js.map